import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'
import useStyles from './useStyles'

function OrganizationTable ({ rows, setRows, setLoading }) {
  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />

            <tbody className={classes.tableBody}>
              {rows.map((item, index) => (
                <TableItem
                  listIndex={index}
                  key={item.organizationId}
                  item={item}
                  setLoading={setLoading}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default OrganizationTable
